import { paymentParams} from "../../../store/payLinkStore";
import http from "../../../helpers/http";

export const generateHash = async (order: string, reference: string, amount: string
        ):Promise<any> => {
            const data_hash = {
                order,
                reference,
                amount
            };
            try{
                debugger
                const { data } = await http.post<any>(`fines/generate-hash`, data_hash);
                console.log("Hash recibido: ", data);
                return data;
            
            }catch(err){
                console.log("Ha ocurrido un error", err)
            }
  };

//   export const generatePaymentURL = (paymentInfo: paymentParams) => {
//     const baseURL = "https://adquiracloud.mx/multipagos/";

//     const params = new URLSearchParams({
//         mp_account: paymentInfo.mp_account,
//         mp_product: paymentInfo.mp_product,
//         mp_order: paymentInfo.mp_order,
//         mp_reference: paymentInfo.mp_reference,
//         mp_node: paymentInfo.mp_node,
//         mp_concept: paymentInfo.mp_concept,
//         mp_amount: paymentInfo.mp_amount,
//         mp_currency: paymentInfo.mp_currency,
//         mp_customername: paymentInfo.mp_customername,
//         mp_urlsuccess: paymentInfo.mp_urlsuccess,
//         mp_urlfailure: paymentInfo.mp_urlfailure,
//         mp_boleta: paymentInfo.mp_boleta,
//     });


//     if (paymentInfo.mp_hash) {
//         params.append("mp_hash", paymentInfo.mp_hash);
//     }

//     return `${baseURL}?${params.toString()}`;
// };


//const paymentURL = generatePaymentURL(paymentInfo);
export const generatePaymentURLBBVA = (paymentInfo: paymentParams) => {
    const baseURL = "https://www.adquiramexico.com.mx/";

    const bbva_params = new URLSearchParams(
        Object.entries({
            s_transm: paymentInfo.s_transm,
            c_referencia: paymentInfo.c_referencia,
            t_servicio: paymentInfo.t_servicio,
            t_importe: paymentInfo.t_importe,
            val_1: paymentInfo.val_1,
            val_3: paymentInfo.val_3,
            mp_signature: paymentInfo.mp_signature,
        }).map(([key, value]) => [key, String(value)]) // Convierte solo si es necesario
    );

    return `${baseURL}?${bbva_params.toString()}`;
};

